import { useModule, videoVotingModuleQuery } from 'system/structure-modules';

export default function VideoVotingIndexScreen() {
    const { VideoVotingSidebarScreen } = useModule(videoVotingModuleQuery);
    return <VideoVotingSidebarScreen />;
}
